import Tasks from 'APP/Tasks';
import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export function toggleUserNotifications(): void {
  if (Entities.App.isOfflineNetworkStatus) {
    return;
  }
  const newValue = !Entities.pushNotifications.isEnabled;

  storage.pushNotifications.set(Entities.usersStore.Me.id, newValue);

  Entities.pushNotifications.setEnabled(newValue);

  if (newValue) {
    Tasks.pushNotifications.subscribeNotifications();
  } else {
    Tasks.pushNotifications.unsubscribeNotifications();
  }
}
